export default __webpack_public_path__ + "static/media/PlayButton.865a9d0e.png";